import React from 'react'

const FoodCoupons = () => {
    return (
        <div>FoodCoupons</div>
    )
}

export default FoodCoupons